import { computed } from 'vue';
import { IInputStringEvent } from '@/models/input-events.interface';
import { ValidationProperties } from '@/models/validation.interface';
import validationPresenter from '@/presenters/validation-presenter';
import store from '@/store';

export default class CrmIdCode {

	public storedCrmId = computed((): number | null => {
		return store.getters.crmId();
	});

	public isFieldValidatedAndMissing = computed((): boolean => {
		return validationPresenter.isPropertyMissing(ValidationProperties.CRM_ID);
	});

	public isFieldValidatedAndInvalid = computed((): boolean => {
		return validationPresenter.isPropertyInvalid(ValidationProperties.CRM_ID);
	});

	public setCrmIdBasedOnEvent(event: IInputStringEvent): void {
		const value = event?.target?.value;
		if (value === undefined) {
			return;
		}

		store.mutations.setCrmId(parseInt(value));

		if (!this.isFieldValidatedAndMissing.value && !this.isFieldValidatedAndInvalid.value) {
			return;
		}

		validationPresenter.validateMandatoryFields();
	}
}
